import { createApp } from "vue";
import { firebaseAuth } from "./common/firebase";
import { onAuthStateChanged } from "firebase/auth";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// styles
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/css/tailwind.css";
import "@/assets/css/abi.css";

let app;

onAuthStateChanged(firebaseAuth, () => {
  if (!app) {
    app = createApp(App).use(store).use(router).mount("#app");
  }
});
